<script setup lang="ts">
import SvgIcon from "~/components/Common/SvgIcon.vue";
import Tooltip from "~/components/Common/Tooltip.vue";

const props = defineProps<{
  to: string;
  label: string;
  icon: string;
  activeIcon?: string;
  active: boolean;
  collapsed: boolean;
}>();

const iconName = computed<string>(() => (props.active && props.activeIcon ? props.activeIcon : props.icon));
</script>

<template>
  <Tooltip
    class="w-full"
    position="mid-right"
    append-to-body
    minified
    open-on-focus
    :force-position-left="10"
    :disabled="!collapsed || active"
  >
    <template #img>
      <!-- `tab` and `data-tab` are the hooks the E2E suite reads the active entry from. -->
      <NuxtLink
        :to="to"
        :data-tab="active"
        class="tab group flex h-9 w-full items-center gap-[10px] overflow-hidden rounded-[6px] py-1.5 transition-[padding,background-color,box-shadow] duration-[180ms] ease-out motion-reduce:transition-none"
        :class="[
          collapsed ? 'pl-3' : 'px-2',
          active
            ? 'bg-light-color text-primary-color shadow-[shadow:var(--shadow-subtle)]'
            : 'text-secondary-color hover:bg-hover-grey-color',
        ]"
      >
        <span class="flex size-6 shrink-0 items-center justify-center">
          <SvgIcon
            :name="iconName"
            class="size-4 text-secondary-color transition-transform duration-[180ms] ease-out motion-reduce:transition-none"
            :class="{ 'group-hover:-rotate-[10deg]': !active }"
          />
        </span>
        <span
          class="body_med min-w-0 flex-1 truncate leading-5 transition-opacity duration-200 ease-out motion-reduce:transition-none"
          :class="{ 'opacity-0': collapsed }"
        >
          {{ label }}
        </span>
      </NuxtLink>
    </template>
    <template #content>
      <span class="small_med whitespace-nowrap">{{ label }}</span>
    </template>
  </Tooltip>
</template>
